// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".92d13c40a4d431cdc1ca2887f784d06e8db64d97.chunk.js";
};